module.exports = __webpack_public_path__ + "img/image_icon.3558acf5.png";